import React, { useState } from 'react'
import { Box, Typography, Checkbox } from '@mui/material'
import ContentIcon from './ContentIcon'

function ContentItem(props) {
  const [hover, setHover] = useState(false)

  const activeColor = '#1E88E5'
  const hoverColor = 'rgba(30, 136, 229, 0.04)'
  const borderColor = props.active ? activeColor : (hover ? 'rgba(30, 136, 229, 0.2)' : 'rgba(0,0,0,0.06)')

  return (
    <Box
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={props.onClick}
      sx={{
        backgroundColor: props.active ? 'rgba(30, 136, 229, 0.08)' : (hover ? hoverColor : '#fff'),
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: '16px',
        p: 1.5,
        cursor: 'pointer',
        border: `1px solid ${borderColor}`,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        transform: hover ? 'translateY(-2px)' : 'none',
        boxShadow: hover ? '0 10px 25px rgba(0,0,0,0.06)' : 'none',
        overflow: 'hidden',
        position: 'relative',
        '&::after': props.active ? {
          content: '""',
          position: 'absolute',
          left: 0,
          top: '20%',
          bottom: '20%',
          width: '4px',
          backgroundColor: activeColor,
          borderRadius: '0 4px 4px 0',
        } : {},
      }}
    >
      {props.checkBox && (
        <Checkbox
          checked={!!props.active}
          size="medium"
          sx={{
            p: 0.5,
            mr: 1.5,
            color: 'rgba(0,0,0,0.2)',
            '&.Mui-checked': { color: activeColor },
          }}
        />
      )}

      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: props.active ? '#fff' : 'rgba(0,0,0,0.04)',
        borderRadius: '10px',
        width: 36,
        height: 36,
        mr: 1.5,
        transition: 'all 0.3s ease',
        flexShrink: 0,
        boxShadow: props.active ? '0 4px 10px rgba(30, 136, 229, 0.1)' : 'none',
      }}>
        <ContentIcon contentType={props.contentType} size="1.4rem" fontSize="1.3rem" />
      </Box>

      <Typography
        variant="body1"
        sx={{
          flex: 1,
          fontWeight: 700,
          color: props.active ? activeColor : '#1E293B',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          fontSize: '0.9rem',
          fontFamily: "'Inter', sans-serif",
        }}
      >
        {props.text}
      </Typography>
    </Box>
  )
}

export default ContentItem
